"use client";
//#region packages/@mantine/core/src/components/Combobox/OptionsDropdown/is-options-group.ts
function isOptionsGroup(item) {
	return "group" in item;
}
//#endregion
export { isOptionsGroup };

//# sourceMappingURL=is-options-group.mjs.map